var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon / Failure !") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u24E7-Error-Handling",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Enter-Phone-Copy",
    transform: "translate(-299.000000, -101.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "!",
    transform: "translate(299.000000, 101.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Check",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 15,
    cy: 15,
    r: 15
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(11.277174, 4.000000)",
    fill: "#FA0000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Line-4",
    points: "5.72282609 18.0014258 1.79419877 18 1.72282609 21.9985742 5.6514534 22"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Line-4",
    points: "6.72282609 0.00922116715 0.722826087 -8.14973089e-14 2.35925584 14.9907788 4.93067648 15"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedX);
export default __webpack_public_path__ + "static/media/red-x.a0d6c4ba77b72a18c5692c80560771c6.svg";
export { ForwardRef as ReactComponent };